import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {budgetFilterDefaults} from "../../real_estate/constants/budget_filter_defaults";

export const usePriceRanges = () => {
    const regionsData = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const abroadStats = useSelector((state: IRPStore) => state.investmentOffer?.stats?.abroad);
    const queryPrice = latestQuery.price_1 && parseInt(latestQuery.price_1);
    let maxPrice = budgetFilterDefaults.totalMax;

    if (regionsData) {
        maxPrice = regionsData.reduce((acc, region) => {
            const maxRegionPrice = Math.max(
                region?.stats?.properties_houses_ranges_price_max || 0,
                region?.stats?.properties_flats_ranges_price_max || 0,
                region?.stats?.properties_commercials_ranges_price_max || 0,
                region?.stats?.properties_studios_ranges_price_max || 0
            );
            return maxRegionPrice > acc ? maxRegionPrice : acc;
        }, maxPrice);
    }

    if (abroadStats && regionsData.length === 0) {
        maxPrice = abroadStats.spain_max_price;
    }

    if (queryPrice && queryPrice > maxPrice) {
        maxPrice = queryPrice;
    }

    return {
        maxPrice: Math.ceil(maxPrice / 100000) * 100000
    };
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {budgetFilterDefaults} from "../../real_estate/constants/budget_filter_defaults";

export const usePriceRanges = () => {
    const regionsData = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const abroadStats = useSelector((state: IRPStore) => state.investmentOffer?.stats?.abroad);
    const queryPrice = latestQuery.price_1 && parseInt(latestQuery.price_1);
    let maxPrice = budgetFilterDefaults.totalMax;

    if (regionsData) {
        maxPrice = regionsData.reduce((acc, region) => {
            const maxRegionPrice = Math.max(
                region?.stats?.properties_houses_ranges_price_max || 0,
                region?.stats?.properties_flats_ranges_price_max || 0,
                region?.stats?.properties_commercials_ranges_price_max || 0,
                region?.stats?.properties_studios_ranges_price_max || 0
            );
            return maxRegionPrice > acc ? maxRegionPrice : acc;
        }, maxPrice);
    }

    if (abroadStats && regionsData.length === 0) {
        maxPrice = abroadStats.spain_max_price;
    }

    if (queryPrice && queryPrice > maxPrice) {
        maxPrice = queryPrice;
    }

    return {
        maxPrice: Math.ceil(maxPrice / 100000) * 100000
    };
};
